import Axios from "axios";

export const gatAllOackageWithoutPagination = (obj) => {
  return Axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE + "/packageWithoutPagination",
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getAllChallangeGroups = (obj, page = 1, searchParam = "") => {
  return Axios.get(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/challenge-groups?page=${page}&search=${searchParam}`,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log("Error in getAllChallangeGroups:", err);
      return null;
    });
};

export const addChallenge = (body, obj) => {
  return Axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/challenges`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: `Bearer ${obj}`,
      },
    }
  )
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const assignGroups = (body, obj) => {
  return Axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/challenges/groups/assign-leads`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: `Bearer ${obj}`,
      },
    }
  )
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const addChallengeGroup = (body, obj) => {
  return Axios.post(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/challenges/1/groups`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: `Bearer ${obj}`,
      },
    }
  )
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const getAllChallengers = (
  obj,
  searchParam = "",
  number = 1,
  type = ""
) => {
  return Axios.get(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/challenges?page=${number}&search=${searchParam}&type=${type}`,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => res)
    .catch((err) => {
      console.error("Error fetching challengers:", err);
    });
};

export const DeleteChallenge = (id, obj) => {
  return Axios.delete(
    process.env.REACT_APP_NOT_SECRET_CODE + "/challenges/" + id,
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllChallageGroupList = (obj, challenge_id) => {
  return Axios.get(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/challenges/${challenge_id}/groups`,
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const GetChallengeById = (id, obj) => {
  return Axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE + "/challenges/" + id,
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
// export const getAllGroups = (obj) => {
//   return Axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/leadgroups", {
//     headers: {
//       "Content-Type": "application/json ",
//       "X-Request-ID": "124",
//       "X-Country-Code": "BD",
//       "X-Client-Name": "WEBSITE",
//       "X-Client-Version": "123",
//       Authorization: "Bearer " + obj,
//     },
//   })
//     .then((res) => {
//       return res;
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const updateChallageDetails = (id, challenge, obj) => {
  return Axios.put(
    process.env.REACT_APP_NOT_SECRET_CODE + "/challenges/" + id,
    challenge,
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const serachByLeads = (name, obj) => {
  let url = "";
  url =
    process.env.REACT_APP_NOT_SECRET_CODE +
    "/leads?status=3&search_subscriber=" +
    name +
    "&records_per_page=100000000000";
  return Axios.get(url, {
    headers: {
      "Content-Type": "application/json ",
      "X-Request-ID": "124",
      "X-Country-Code": "BD",
      "X-Client-Name": "WEBSITE",
      "X-Client-Version": "123",
      Authorization: "Bearer " + obj,
    },
  }).then((res) => {
    return res.data;
  });
};

export const getAssignLeadsByGroupId = (id, obj) => {
  return Axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE + "/challenge-groups-leads/" + id,
    {
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error("API error:", err);
      return null;
    });
};

// export const deleteGroupChallenge = (id, obj) => {
//   return Axios.delete(
//     process.env.REACT_APP_NOT_SECRET_CODE +
//       "/delete-challenge-groups-lead/" +
//       id,
//     {
//       headers: {
//         "Content-Type": "application/json ",
//         "X-Request-ID": "124",
//         "X-Country-Code": "BD",
//         "X-Client-Name": "WEBSITE",
//         "X-Client-Version": "123",
//         Authorization: "Bearer " + obj,
//       },
//     }
//   )
//     .then((res) => {
//       return res;
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const getChallengeList = (obj) => {
  return Axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE + "/getChallengeList",
    {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    }
  )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
